import { useTranslation } from 'react-i18next'
import React from 'react'

import AvailabilityStatusSelect from '../../../../../availability/_shared/AvailabilityStatusSelect'
import { useFormState } from '../../../../../../packages/kiti/components/form/form/FormHandler'
import EditableSentence from '../../EditableSentence'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import Modal from '../../../../../../components/structure/Modal'
import SubmitBar from '../../../../../../packages/kiti/components/form/SubmitBar'
import TextArea from '../../../../../../packages/kiti/components/form/Textarea'
import Text, { Title } from '../../../../../../packages/kiti/components/presentation/Text'
import Separator from '../../../../../../packages/kiti/components/helpers/Separator'
import { Col, Grid } from '../../../../../../packages/kiti/components/structure/Grid'

const SetAvailabilityStatusSentence = () => {
  const { t } = useTranslation(['triggers', 'availability'])
  const [open, setOpen] = React.useState()
  const { form } = useFormState()

  const status = form.payload?.status

  return (
    <>
      <Text size="h2">{t('availability:changeStatusTo')} </Text>
      <EditableSentence
        label={status ? t(`availability:status.${status}`) : '_______'}
        truncate={20}
        onClick={() => setOpen(true)}
        field="payload"
      />

      <Modal open={open} onClose={() => setOpen(false)} width="28rem">
        <Title size="h5" bold>
          {t('actions.set_availability_status')}
        </Title>
        <Separator weight={4} />

        <Grid paddingGutter={0.5} wrap>
          <Col width="100%">
            <FormItem
              label={t('availability:changeStatusTo')}
              path={['payload', 'status']}
              Input={AvailabilityStatusSelect}
            />
          </Col>

          <Col width="100%">
            <FormItem label={t('availability:reason')} path={['payload', 'reason']} Input={TextArea} />
          </Col>
        </Grid>

        <SubmitBar onClick={() => setOpen(false)} />
      </Modal>
    </>
  )
}

export default SetAvailabilityStatusSentence
